import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import CargomaticInput from 'components/v2/input';
import Spinner from 'components/ui/Spinner';
import Alert from 'components/ui/Alert';
import { getMissingReferenceNumbers } from 'utils/ShipmentWebAPIUtils';
import { isIntermodalShipmentType } from 'helpers/shipment-types';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';

export default function MissingReferenceNumbers({
  stop,
  shipment,
  onInputChange,
  dataTestId
}) {
  const { t } = useTranslation();
  const action = stop?.action;

  const [isLoading, setIsLoading] = useState(true);
  const [currMissingReferenceNumbers, setCurrMissingReferenceNumbers] =
    useState([]);

  async function fetchMissingReferencNumbers(shipment) {
    try {
      const {
        entity: {
          result: { present, ...missingReferenceNumbers },
        },
      } = await getMissingReferenceNumbers(shipment);

      const currStage = findCurrentStage(action);
      setCurrMissingReferenceNumbers(
        missingReferenceNumbers[currStage]?.missing ?? [],
      );
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  }

  function findCurrentStage(action) {
    switch (action) {
      case 'pickup':
        return 'PRIOR_TO_PICKUP';
      case 'deliver':
        return 'PRIOR_TO_DELIVERY';
      default:
    }
  }

  useEffect(() => {
    setIsLoading(true);
    if (featureEnabled(CONFIGURED_FEATURES.SSR) && isIntermodalShipmentType(shipment)) {
      fetchMissingReferencNumbers(shipment);
    }
  }, []);

  function renderSpinner() {
    return <Spinner data-testid={dataTestId} />;
  }

  function renderMissingReferenceNumbers() {
    if (currMissingReferenceNumbers?.length) {
      return (
        (<div data-testid={dataTestId} className="mt-3 mb-4">
          <hr data-testid="hr-f490e19c" />
          <Alert dataTestId="Alert-1e3f7825" type="warning"> {t('PLEASE_PROVIDE_REFERENCE_NUMBERS')}</Alert>
          <div data-testid="div-f17d431b" className="mb-4 mt-4 grid grid-cols-3 gap-4">
            {currMissingReferenceNumbers.map((missingReferenceNumber, index) => (<CargomaticInput
              dataTestId={`CargomaticInput-1f126bcc-${index}`}
              id={missingReferenceNumber}
              label={t(missingReferenceNumber?.toUpperCase())}
              type="text"
              onChange={(value) =>
                onInputChange(missingReferenceNumber, value)
              } />))}
          </div>
        </div>)
      );
    }

    return <div data-testid="div-292d2fc0" />;
  }

  return isLoading ? renderSpinner() : renderMissingReferenceNumbers();
}
